export default __webpack_public_path__ + "static/media/(1).27f4adbd.jpg";